export default "__VITE_ASSET__DWHSIGeH__"